// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._343EhxI8lu8-ih {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  overflow: auto;\n  width: 100vw;\n}\n._3Qi5S5c7beYoOz {\n  background: rgba(0, 0, 0, 0.6);\n}\n._2E51xGpnYJSdNA {\n  background: rgba(0, 0, 0, 0.75);\n}\n._3Rzqg7dIYw-6jk {\n  background: transparent;\n  position: relative;\n  margin: 48px 0;\n  width: auto;\n}\n._3Rzqg7dIYw-6jk:focus {\n  outline: none;\n}\n._2U9LyyXo2UnPgK {\n  align-items: flex-start;\n}\n@media only screen and (max-width: 750px) {\n  ._3Rzqg7dIYw-6jk {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": "_343EhxI8lu8-ih",
	"light": "_3Qi5S5c7beYoOz",
	"dark": "_2E51xGpnYJSdNA",
	"contents": "_3Rzqg7dIYw-6jk",
	"alignTop": "_2U9LyyXo2UnPgK"
};
export default ___CSS_LOADER_EXPORT___;
